import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { ShipmentSummary } from "@redotech/redo-fulfillment-group-common/shipment-summary";

export function getEffectiveShipmentSummary(
  data: FulfillmentGroupData | undefined,
): ShipmentSummary | null {
  return data?.shipmentSummary ?? null;
}
